export enum EventType {
  triviaMaticDemo = 'Triviamatic Demo',
}
